import { Component, Vue } from "vue-property-decorator";
import VueCookies from 'vue-cookies'
import EditMemberComponent from '../Component/EditMember.component.vue';
Vue.use(VueCookies)

@Component({
    components: {
        EditMemberComponent
    }
})
default class EditMember extends Vue {
   
}
export default EditMember